export default __webpack_public_path__ + "static/media/aboutApplication.fe815439.svg";